// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"1239":"css/app.6734","9509":"css/admin-app.6734"}[chunkId] + ".css";
};